import axios from '../axios';

export default {
  getArticles (options = {}) {
    const params = {};
    if (options.page) params.page = options.page;
    if (options.limit) params.limit = options.limit;
    if (options.sort) params.sort = options.sort;
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }
    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    return new Promise((resolve, reject) => {
      axios.get('/articles' + (query.length ? '?' + query.join('&') : ''))
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
  getArticle (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/articles/${id}`)
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
  createArticle (data) {
    return new Promise((resolve, reject) => {
      const config = {};
      if (data instanceof FormData) {
      } else {
        config.headers = { 'Content-Type': 'application/json' };
      }
      axios.post('/articles', data, config)
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
  updateArticle (id, data) {
    return new Promise((resolve, reject) => {
      const config = {};
      if (data instanceof FormData) {
      } else {
        config.headers = { 'Content-Type': 'application/json' };
      }
      axios.put(`/articles/${id}`, data, config)
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
  deleteArticle (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/articles/${id}`)
        .then((response) => resolve(response))
        .catch(error => reject(error));
    });
  },
};
